import { useEffect, useMemo } from "react";
import { useAddCheckList, useEditCheckList, useFetchChecklists, useUpdateChecklists } from "../mutation";

export const useFetchChecklist = (stageID: string, page: number = 1) => {

    const checkList = useFetchChecklists();
    const updateCheckList = useUpdateChecklists();
    const addCheckList = useAddCheckList();
    const editCheckList = useEditCheckList();

    const fetch = async (currentPage: number) => {
        if (!stageID || stageID === "null" || stageID === "undefined") return;
        await checkList.mutateAsync({ 
            search_term: null, 
            object_type: ['checklist'], 
            object_id: Number(stageID) || null, 
            my_tasks: false,
            page: currentPage,
            limit: 20
        });
    };

    const create = async (payload: { task_name: string; user_id: number; is_evidence_required: boolean; is_required: boolean; object_type: string; object_id: number | null; }) => {
        await addCheckList.mutateAsync({ payload });
        await fetch(1); // Fetch page 1 after a new item is created
    };

    const edit = async (checkListID: string, payload: { task_name: string; user_id: number; is_evidence_required: boolean; is_required: boolean; object_type: string; object_id: number | null; }) => {
        await editCheckList.mutateAsync({ payload, checkListID });
        await fetch(page);
    };

    const update = async (checkListID: string, object_type: string, object_id: number | null) => {
        const payload = { status: "completed", object_type: object_type, object_id: object_id };
        await updateCheckList.mutateAsync({ checkListID, payload });
        await fetch(page);
    };

    useEffect(() => {
        if (stageID && stageID !== "null" && stageID !== "undefined") {
            fetch(page);
        }
    }, [stageID, page]);

    const data = useMemo(
        () => (checkList.isSuccess ? checkList?.data?.data?.rows || [] : []),
        [checkList.isSuccess, checkList?.data?.data?.rows]
    );

    return {
        isPending: checkList.isPending,
        isUpdating: updateCheckList.isPending,
        isAdding: addCheckList.isPending,
        isEditing: editCheckList.isPending,
        data,
        pagination: checkList.isSuccess ? checkList?.data?.data?.pagination : null,
        handleUpdateCheckList: update,
        handleAddChecklist: create,
        handleEditChecklist: edit,
    };

};